import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Copy, Optional, Icon } from '@honda-canada/design-system-react';
import kebabCase from 'lodash/kebabCase';
import { compiler } from 'markdown-to-jsx';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addSelectedFilterItemAction, removeSelectedFilterItemAction, selectEnabledFilterItems, selectIsItemSelected, } from '../../../core/reducers/vehicleListFilters';
import themeStyles from '../VehicleListFilters.styles';
import { useUserOrDefaultProvince } from '../../../utils/sitecoreContext';
const CheckmarkIcon = themeStyles.apply(Icon, 'CheckmarkIcon');
const ImageButton = themeStyles.apply('button', 'ImageButton');
const Image = themeStyles.apply('img', 'Image');
const ImageLabel = themeStyles.apply(Copy, 'ImageLabel');
const Label = themeStyles.apply(Copy, 'Label');
const SOFT_HYPHEN_CHARACTER = '\u00AD';
const FiltersSectionItem = ({ item, parentTestId }) => {
    const { icon, label, key } = item;
    const [, filterValue] = item.key.split('|');
    const { src, alt } = icon || {};
    const hasImage = !!src;
    const formatLabelTestId = kebabCase(label);
    const softHyphenatedLabel = label === null || label === void 0 ? void 0 : label.replace(/-/g, SOFT_HYPHEN_CHARACTER);
    const provinceCode = useUserOrDefaultProvince();
    const dispatch = useDispatch();
    const isSelected = useSelector(selectIsItemSelected(key));
    const enabledFilterItems = useSelector(selectEnabledFilterItems(provinceCode));
    const isDisabled = !enabledFilterItems.some(enabledFilterItem => {
        const parts = enabledFilterItem.split('|');
        return parts[1] === filterValue;
    });
    const tabIndexValue = isDisabled ? -1 : 0;
    const handlerClickFilterItem = () => {
        if (isDisabled) {
            return;
        }
        if (isSelected) {
            dispatch(removeSelectedFilterItemAction(key));
            return;
        }
        dispatch(addSelectedFilterItemAction(key));
    };
    return (_jsxs(_Fragment, { children: [_jsx(Optional, { when: hasImage && label, children: _jsxs(ImageButton, { active: isSelected, disabled: isDisabled, onClick: handlerClickFilterItem, "data-testid": `cy-${formatLabelTestId}-tag`, tabIndex: tabIndexValue, children: [_jsx(Image, { src: src, alt: alt }), _jsx(ImageLabel, { dangerouslySetInnerHTML: { __html: softHyphenatedLabel }, size: "small", "data-testid": `cy-${parentTestId}-${formatLabelTestId}-image-label` })] }) }), _jsx(Optional, { when: !hasImage && label, children: _jsxs(Label, { as: "button", size: "small", active: isSelected, disabled: isDisabled, onClick: handlerClickFilterItem, "data-testid": `cy-${formatLabelTestId}-tag`, tabIndex: tabIndexValue, children: [_jsx(Optional, { when: isSelected, children: _jsx(CheckmarkIcon, { iconColor: "white", name: "checkmark" }) }), compiler(label)] }) })] }));
};
export default FiltersSectionItem;
